const addLayer = (state, {layer, style, position}) => {
  if (!state.layers.some(x => x.layerId === layer.objectid)) {
    state.layers.push({
      layerId: layer.objectid,
      body: layer,
      draft: {
        select: [],
        where: {
          attributeFilters: [],
          spatialFilters: [],
        },
        groupBy: [],
        having: [],
        orderBy: [],
        dirty: false
      },
      position: position,
      applied: null,
      style: style,
      visible: false
    })
  }
}
const removeLayer = (state, layerId) => {
  const index = state.layers.findIndex(x => x.layerId === layerId)
  if (index > -1) state.layers.splice(index, 1)
}
const resetLayers = (state) => {
  state.layers = []
}
const setActiveProject = (state, { activeProject }) => {
  state.activeProjectId = activeProject.objectid
  state.activeProject = activeProject || null
}
const setError = (state, error) => {
  state.error = error
}
const setOptions = (state, options) => {
  state.options = options || {}
}
const setStatus = (state, status) => {
  state.status = status
}
const setUploadLayers = (state, layers) => {
  state.uploadLayers = layers
}

export default {
  addLayer,
  removeLayer,
  resetLayers,
  setActiveProject,
  setError,
  setOptions,
  setStatus,
  setUploadLayers
}
